import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';

import quotes from '../images/main/quotes.svg';

import vlad from '../images/vlad.jpg';
import ivan from '../images/ivan.jpg';
import andrey from '../images/andrey.jpg';

const StyledReview = styled.div`
    padding: 82px 0 100px 24px;

    @media screen and (max-width: 1024px) {
        padding: 64px 0 64px 24px;
    }

    @media screen and (max-width: 760px) {
        padding: 64px 0 74px 24px;
    }

    .slick-list {
        overflow: visible;
        margin-bottom: 64px;
    }

    .slick-slide {
        padding: 0 24px 0 0;
        box-sizing: border-box;
        height: inherit !important;
        > div {
            height: 100%;
        }
    }
    .slick-track {
        display: flex !important;
    }
    .slick-dots {
        bottom: -64px;
        li button,
        li button:before {
            width: 16px;
            height: 16px;
            opacity: 1;
        }
    }
`;

const StyledReviewItem = styled.div`
    max-width: 100%;
    background: #ffffff;
    box-shadow: 10px 15px 20px -5px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    padding: 32px 32px 83px;
    box-sizing: border-box;
    position: relative;
    margin: 32px 0 64px;
    outline: none;
    height: calc(100% - 58px);

    &:before {
        content: '';
        display: block;
        background-image: url(${quotes});
        background-repeat: no-repeat;
        background-size: cover;
        width: 61px;
        height: 50px;
        position: absolute;
        z-index: 10;
        left: 5px;
        top: -30px;
    }

    @media screen and (max-width: 760px) {
        padding-bottom: 78px;

        & + & {
            margin: 74px 0 0;
        }
    }
`;

const StyledReviewItemText = styled.div`
    font-size: 18px;
    line-height: 140%;
    color: #2d2d2d;

    @media screen and (max-width: 1024px) {
        font-size: 14px;
        line-height: 150%;
    }
`;

const StyledReviewAuthor = styled.div`
    position: absolute;
    display: flex;
    align-items: flex-start;
    bottom: -24px;
    max-width: calc(100% - 36px);
    width: 100%;

    @media screen and (max-width: 1024px) {
        bottom: -16px;
    }

    @media screen and (max-width: 760px) {
        bottom: -10px;
    }
`;

const StyledReviewAuthorImage = styled.img`
    max-width: 88px;
    height: auto;
    display: block;
    border-radius: 50%;

    @media screen and (max-width: 1024px) {
        max-width: 72px;
    }

    @media screen and (max-width: 760px) {
        max-width: 64px;
    }
`;

const StyledReviewAuthorName = styled.div`
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
    margin: 4px 0 0 16px;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    max-width: calc(100% - 100px);

    @media screen and (max-width: 1024px) {
        font-size: 14px;
        margin: 0 0 0 8px;
    }

    @media screen and (max-width: 760px) {
        margin: 0 0 0 16px;
        font-size: 18px;
    }
`;

const StyledReviewAuthorInfo = styled.div`
    font-size: 14px;
    line-height: 16px;
    color: #bfbfbf;
    margin: 4px 0 0;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    max-width: 100%;

    @media screen and (max-width: 1024px) {
        font-size: 12px;
    }

    @media screen and (max-width: 760px) {
        margin-top: 0;
        font-size: 14px;
    }
`;

const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    centerPadding: '60px',
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 648,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

const reviewItems = [
    {
        name: 'Владилен Ситников',
        info: 'Креативный директор, Possible',
        review:
            'Когда я&nbsp;начинал изучать английский язык, у&nbsp;меня был совершенно нулевой уровень. Через полгода&nbsp;&mdash; я&nbsp;заговорил. Через год&nbsp;&mdash; без стеснения и&nbsp;на&nbsp;автоматизме мог продолжать беседу. Через два года выступил на&nbsp;первой конференции с&nbsp;докладом. И&nbsp;все это благодаря методу КЭСПА.',
        image: vlad,
    },
    {
        name: 'Иван Глебов',
        info: 'Старший менеджер продукта, Сбер',
        review:
            'В&nbsp;школе никак не&nbsp;мог запомнить грамматику и&nbsp;применять ее&nbsp;в&nbsp;разных ситуациях. Методика КЭСПА помогла заговорить почти не&nbsp;задумываясь о&nbsp;правилах. Если давно хотели подтянуть свой английский, то&nbsp;это отличная возможность.',
        image: ivan,
    },
    {
        name: 'Андрей Волков',
        info: 'Бренд-директор, Skillbox',
        review: `Вернулся к обучению в КЭСПА. Занимался с ними лет 6 назад, с тех пор перепробовал кучу других курсов, но понял, что с КЭСПА мой прогресс в английском был наибольшим. А за эти годы ребята стали еще лучше!`,
        image: andrey,
    },
];

export const ReviewsSlider = () => (
    <StyledReview>
        <Slider {...sliderSettings}>
            {reviewItems.map((item, i) => (
                <StyledReviewItem key={`item-${item.name}`}>
                    <StyledReviewItemText
                        dangerouslySetInnerHTML={{ __html: item.review }}
                    />
                    <StyledReviewAuthor>
                        <StyledReviewAuthorImage
                            src={item.image}
                            alt={item.name}
                        />
                        <StyledReviewAuthorName>
                            {item.name}
                            <StyledReviewAuthorInfo>
                                {item.info}
                            </StyledReviewAuthorInfo>
                        </StyledReviewAuthorName>
                    </StyledReviewAuthor>
                </StyledReviewItem>
            ))}
        </Slider>
    </StyledReview>
);
